export default "__VITE_ASSET__COb4ohya__"